import React, { useCallback, useMemo, useRef } from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import ReactSelect from 'react-select'
import endpoints from '../../../helpers/endpoints'
import request from '../../../helpers/request'
import { GenericTable } from '../VacantCOTAlerts/sharedComponents'
import Button from '../../../components/large-link-button/largeLinkButton'
import ReactModal from 'react-modal'
import hasPermission from '../../../helpers/permissions'

export const Summary = ({summaryData, setSummaryData, workflow = false, translations = {}}) => {
  const [spid, setSpid] = useState()
  const [loadingWorkflow, setLoadingWorkflow] = useState(false)
  const [search, setSearch] = useState()
  const [retDecision, setRetDecision] = useState('')
  const [wsDecision, setWsDecision] = useState('')
  const [retClassification, setRetClassification] = useState('')
  const [wsClassification, setWsClassification] = useState('')
  const [wholesalerNotes, setWholesalerNotes] = useState('')
  const [retailerNotes, setRetailerNotes] = useState('')
  const [workflowItems, setWorkflowItems] = useState([])
  const [workflowCounts, setWorkflowCounts] = useState([])
  const [workflowOutcomeSetting, setWorkflowOutcomeSetting] = useState('New')
  const getSummaryData = useCallback(() => {
    setSearch()
    setSummaryData({})
    setRetDecision('')
    setWsDecision('')
    request(true).get(endpoints.MOSL_ELIGIBILITY_SEARCH_BY_SPID, {
      doesCancel: true,
      params: {
        spid
      }
    }).then(e => {
      setSummaryData(e.data ?? {})
      setWholesalerNotes(e.data.Wholesaler_Comments ?? '')
      setRetailerNotes(e.data.Retailer_Comments ?? '')
      setWsClassification(e.data.Wholesaler_Premises_Classification ?? '')
      setRetClassification(e.data.Retailer_Premises_Classification ?? '')
      setWsDecision(e.data.Wholesaler_Decision)
      setRetDecision(e.data.Retailer_Decision)
    }).catch(e => {
      setSummaryData({})
      setWholesalerNotes('')
      setRetailerNotes('')
      setWsClassification('')
      setRetClassification('')
      setWsDecision('')
      setRetDecision('')
      window.alert('Could not find SPID.')
    })
  }, [spid, setSummaryData])

  useEffect(() => {
      window.reloadSummaryData = getSummaryData
  }, [getSummaryData])

  const getWorkflowItems = () => {
    setLoadingWorkflow(true)
    request(true).get(endpoints.MOSL_ELIGIBILITY_WF_ITEMS, {
      doesCancel: true,
      params: {
        outcome: workflowOutcomeSetting
      }
    }).then(e => {
      setWorkflowItems(e.data);
      if (e.data.length > 0) {
        setSpid(e.data[_cur && _cur !== -1 ? _cur : 0])
      } else {
        setSearch()
        setSpid()
        setSummaryData({})
        setWholesalerNotes('')
        setRetailerNotes('')
        setWsClassification('')
        setRetClassification('')
        setWsDecision('')
        setRetDecision('')
      }
      setLoadingWorkflow(false);
    }).catch(e => {
      console.log(e);
      window.alert('Could not retrieve data')
      setLoadingWorkflow(false)
    })
  }

  const getWorkflowCounts = () => {
    setSearch()
    setSummaryData({})
    setRetDecision('')
    setWsDecision('')
    request(true).get(endpoints.MOSL_ELIGIBILITY_WF_COUNTTS).then(r => {
      setWorkflowCounts(r.data);
    })
  }

  useEffect(() => {
      window.reloadWorkflow = getWorkflowItems
  }, [getWorkflowItems])

  var _cur = useMemo(() => {
    return workflowItems.findIndex(_ => _ === spid);
  }, [workflowItems, spid]);

  const refreshCounts = () => {
    if (summaryData.Wholesaler_Decision !== wsDecision || summaryData.Retailer_Decision !== retDecision) {
      getWorkflowItems()
      getWorkflowCounts()
    }
  }

  const getWorkflowNext = () => {
    if (_cur !== workflowItems.length-1) {
      refreshCounts()
      setSpid(workflowItems[_cur+1]);
    }
  }

  const getWorkflowLast = () => {
    if (_cur !== 0) {
      refreshCounts()
      setSpid(workflowItems[_cur-1]);
    }
  }

  const updateOutcome = () => {
    request(true).post(endpoints.MOSL_ELIGIBILITY_UPDATE_OUTCOMES, {
      SPID: spid,
      Wholesaler_Decision: wsDecision,
      Retailer_Decision: retDecision,
      Wholesaler_Classification: wsClassification,
      Retailer_Classification: retClassification
    }).then(r => {
      setSummaryData({
        ...summaryData, 
        Ret_Outcome: r.data?.Ret_Outcome,
        WS_Outcome: r.data?.WS_Outcome,
        Retailer_Decision: r.data?.Retailer_Decision,
        Wholesaler_Decision: r.data?.Wholesaler_Decision
      })
    }).catch(e => {
      console.log(e)
      window.alert("Update failed.")
    })
  }

  const submitNotes= (noteType) =>{
    request(true).post(endpoints.MOSL_ELIGIBILITY_SUBMIT_NOTES, {
      SPID: spid,
      notes: noteType === "Wholesaler" ? wholesalerNotes : retailerNotes,
      noteType: noteType
    }).then(e => {
      // window.alert(e.data);
      window.alert("Note submitted")
    }).catch(e => {
      console.log(e)
      window.alert("Update failed.")
    })
  }

  useEffect(() => {
    getWorkflowCounts()
  }, [])

  useEffect(() => {
    if (
      retDecision && summaryData?.Retailer_Decision && retDecision !== summaryData?.Retailer_Decision || 
      wsDecision && summaryData?.Wholesaler_Decision && setWsDecision !== summaryData?.Wholesaler_Decision || 
      retClassification && summaryData?.Retailer_Premises_Classification && retClassification !== summaryData?.Retailer_Premises_Classification || 
      wsClassification && summaryData?.Wholesaler_Premises_Classification && wsClassification !== summaryData?.Wholesaler_Premises_Classification
    ) {
      updateOutcome()
    }
  }, [retDecision, wsDecision, retClassification, wsClassification])

  useEffect(() => {
    _cur = 0;
  }, [workflowOutcomeSetting])

  useEffect(() => {
    if (workflow) {
      getWorkflowItems();
    }
  }, [workflowOutcomeSetting])

  useEffect(() => {
    if (spid) {
      getSummaryData()
    }
  }, [spid])

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      setSpid(search ? search : spid);
    }
  }

  const outcomes = ["New", "In Progress", "Ongoing Review", "Retailer Pending", "Wholesaler Pending", "Disagree", "Pending Deregistration", "Remain in Market"];

  return (
    <div style={{ display: 'grid', gap: '10px' }}>
      { workflow && 
        <div style={{ display: 'grid', gap: '10px', gridTemplateColumns: `repeat(${outcomes.length}, auto)`, margin: '0em 5em' }}>
          {
            outcomes.map(outcome => {
              const count = workflowCounts.find(wfCount => wfCount?.outcome === outcome);
              return (
                <button className={`button compact smaller-text ${workflowOutcomeSetting === outcome ? "bulk-buy-button" : "background-primary"} colour-white`} onClick={() => {
                  refreshCounts()
                  setWorkflowOutcomeSetting(outcome)
                }}>
                  {outcome} ({count?.count ?? 0})
                </button>
              )
            })
          }
        </div>
      }
      <table className='table borders squish smaller-text left' style={{tableLayout: 'fixed', width: '100%'}}>
      {/* <input type='text' /> */}
        <col width={180} />
        <thead>
          <tr>
            <th colSpan={10}>{translations['Header_Summary']}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td width={400}>{translations['Core_SPID']}</td>
            <td colSpan={5}>
              <div style={{display: 'flex', gap: 10, alignItems: 'center'}}>
                <input style={{border: 'none'}} type="text" onChange={e => setSearch(e.target.value)} value={loadingWorkflow ? '' : search ? search : spid} onKeyDown={handleKeyDown} />
                { loadingWorkflow && <i className="fa fa-spinner fa-spin" style={{ position: 'absolute', paddingLeft: '2px' }}/> }
                {
                  workflow ? <>
                    <span className='fas fa-angle-left colour-primary' style={{cursor: 'pointer'}} onClick={getWorkflowLast}></span>
                    <span>{_cur+1}/{workflowItems.length}</span>
                    <span className='fas fa-angle-right colour-primary' style={{cursor: 'pointer'}} onClick={getWorkflowNext}></span>
                  </> : <>
                  </>
                }
                <span className='fas fa-search colour-primary' style={{cursor: 'pointer'}} onClick={() => setSpid(search)}></span>
              </div>
            </td>
            <td>{translations['Retailer_Assessment']}</td>
            <td colSpan={1}>
              <select disabled={!hasPermission('MOSL_ELIGIBILITY', 'RETAILER')} value={retDecision ? retDecision : summaryData.Retailer_Decision ?? 'New'} onChange={(event) => setRetDecision(event.target.value)} style={{paddingLeft: 0}}>
                <option value="New">New</option>
                <option value="In Progress">In Progress</option>
                <option value="Ongoing Review">Ongoing Review</option>
                <option value="Accepted: HH">Accepted: HH</option>
                <option value="Rejected: NHH">Rejected: NHH</option>
              </select>
            </td>
            <td>{translations['Wholesaler_Assessment']}</td>
            <td colSpan={1}>
              <select disabled={!hasPermission('MOSL_ELIGIBILITY', 'WHOLESALER')} value={wsDecision ? wsDecision : summaryData.Wholesaler_Decision ?? 'New'} onChange={(event) => setWsDecision(event.target.value)} style={{paddingLeft: 0}}>
                <option value="New">New</option>
                <option value="In Progress">In Progress</option>
                <option value="Ongoing Review">Ongoing Review</option>
                <option value="Accepted: HH">Accepted: HH</option>
                <option value="Rejected: NHH">Rejected: NHH</option>
              </select>
            </td>
          </tr>
          <tr>
            <td width='(100/4)%'>{translations['Water_SPID']}</td>
            <td width='(100/4)%'>{summaryData['W_SPID']}</td>
            <td width='(100/4)%'>{translations['Water_Wholesaler']}</td>
            <td width='(100/4)%'>{summaryData['W_Wholesaler_ID']}</td>
            <td width='(100/4)%'>{translations['Water_Retailer']}</td>
            <td width='(100/4)%'>{summaryData['W_Retailer_ID']}</td>
            <td>{translations['Retailer_Classification']}</td>
            <td colSpan={1}>
              <select disabled={!hasPermission('MOSL_ELIGIBILITY', 'RETAILER')} value={retClassification ? retClassification : summaryData.Retailer_Premises_Classification ?? ''} onChange={(event) => setRetClassification(event.target.value)} style={{paddingLeft: 0, backgroundColor: 'unset'}}>
                <option value="" disabled selected></option>
                <option value="Holiday Let/Airbnb/Serviced Apartment">Holiday Let/Airbnb/Serviced Apartment</option>
                <option value="Student Accommodation">Student Accommodation</option>
                <option value="Farm or Field Supply">Farm or Field Supply</option>
                <option value="Mixed Use">Mixed Use</option>
                <option value="Public Building (e.g. Council Village Halls)">Public Building (e.g. Council Village Halls)</option>
                <option value="Other (Add details to free text)">Other (Add details to free text)</option>
              </select>
            </td>
            <td style={{ whiteSpace: 'nowrap'}}>{translations['Wholesaler_Classification']}</td>
            <td colSpan={1}>
              <select disabled={!hasPermission('MOSL_ELIGIBILITY', 'WHOLESALER')} value={wsClassification ? wsClassification : summaryData.Wholesaler_Premises_Classification ?? ''} onChange={(event) => setWsClassification(event.target.value)} style={{paddingLeft: 0, backgroundColor: 'unset'}}>
                <option value="" disabled selected></option>
                <option value="Holiday Let/Airbnb/Serviced Apartment">Holiday Let/Airbnb/Serviced Apartment</option>
                <option value="Student Accommodation">Student Accommodation</option>
                <option value="Farm or Field Supply">Farm or Field Supply</option>
                <option value="Mixed Use">Mixed Use</option>
                <option value="Public Building (e.g. Council Village Halls)">Public Building (e.g. Council Village Halls)</option>
                <option value="Other (Add details to free text)">Other (Add details to free text)</option>
              </select>
            </td>
          </tr>
          <tr>
            <td>{translations['Sewerage_SPID']}</td>
            <td>{summaryData['S_SPID']}</td>
            <td>{translations['Sewerage_Wholesaler']}</td>
            <td>{summaryData['S_Wholesaler_ID']}</td>
            <td>{translations['Sewerage_Retailer']}</td>
            <td>{summaryData['S_Retailer_ID']}</td>
            <td>{translations['Retailer']}</td>
            <td>{summaryData['MOSL_Retailer']}</td>
            <td>{translations['Wholesaler']}</td>
            <td>{summaryData['Wholesaler']}</td>
          </tr>
          <tr>
            <td>{translations['CMOS_UPRN']}</td>
            <td width='(100/4)%'>{summaryData['CMOS_UPRN']}</td>
            <td width='(100/4)%'>{translations['Matched_UPRN']}</td>
            <td width='(100/4)%'>{summaryData['Matched_UPRN']}</td>
            <td width='(100/4)%'>{translations['Status_UPRN']}</td>
            <td width='(100/4)%'>{summaryData['Status_UPRN']}</td>
            <td width='(100/4)%'>{translations['Retailer_Outcome']}</td>
            <td width='(100/4)%'>{summaryData['Ret_Outcome']}</td>
            <td width='(100/4)%'>{translations['Wholesaler_Outcome']}</td>
            <td width='(100/4)%'>{summaryData['WS_Outcome']}</td>
          </tr>
          <tr>
            <td>{translations['CMOS_VOA_No']}</td>
            <td width='(100/4)%'>{summaryData['CMOS_VOA_No']}</td>
            <td width='(100/4)%'>{translations['Matched_VOA_No']}</td>
            <td width='(100/4)%'>{summaryData['Matched_VOA_No']}</td>
            <td width='(100/4)%'>{translations['Status_VOA_No']}</td>
            <td width='(100/4)%'>{summaryData['Status_VOA_No']}</td>
            <td colSpan={2} rowSpan={7} style={{height: '100%'}}>
              <div style={{position: 'relative'}}>
                <textarea disabled={!hasPermission('MOSL_ELIGIBILITY', 'RETAILER')} onChange={(event) => setRetailerNotes(event.target.value.slice(0, 500))} value={retailerNotes ?? ''} rows={12} style={{height: '100%', width: '98%', resize: 'none'}}/>
                <div style={{ position: 'absolute', bottom: 10, right: 5, color: 'gray', fontSize: 12 }}>
                  {retailerNotes.length}/500
                </div>
              </div>
              <button 
                disabled={!hasPermission('MOSL_ELIGIBILITY', 'RETAILER')  || retailerNotes.length < 0} 
                className={`button compact smaller-text ${hasPermission('MOSL_ELIGIBILITY', 'RETAILER') && retailerNotes.length > 0 ? 'background-primary colour-white' : ''}`}
                onClick={() => submitNotes('Retailer')}
                >Submit Notes</button>
            </td>
            <td colSpan={2} rowSpan={7} style={{height: '100%'}}>
              <div style={{position: 'relative'}}>
                <textarea disabled={!hasPermission('MOSL_ELIGIBILITY', 'WHOLESALER')} onChange={(event) => setWholesalerNotes(event.target.value.slice(0, 500))} value={wholesalerNotes ?? ''} rows={12} style={{height: '100%', width: '98%', resize: 'none'}}/>
                <div style={{ position: 'absolute', bottom: 10, right: 5, color: 'gray', fontSize: 12 }}>
                  {wholesalerNotes.length}/500
                </div>
              </div>
              <button 
                disabled={!hasPermission('MOSL_ELIGIBILITY', 'WHOLESALER') || wholesalerNotes.length < 0} 
                className={`button compact smaller-text ${hasPermission('MOSL_ELIGIBILITY', 'WHOLESALER') && wholesalerNotes.length > 0 ? 'background-primary colour-white' : ''}`}
                onClick={() => submitNotes('Wholesaler')}
              >Submit Notes</button>
            </td>
          </tr>
          <tr>
            <td>{translations['CMOS_Address_Single_Line']}</td>
            <td colSpan={'3'}>{summaryData['CMOS_Address_Single_Line']}</td>
            <td>{translations['ABP_GISX']}</td>
            <td>{summaryData['ABP_Easting']}</td>
          </tr>
          <tr>
            <td>{translations['CMOS_UPRN_Single_Line']}</td>
            <td colSpan={'3'}>{summaryData['CMOS_UPRN_Single_Line']}</td>
            <td>{translations['ABP_GISY']}</td>
            <td>{summaryData['ABP_Northing']}</td>
          </tr>
          <tr>
            <td>{translations['Matched_UPRN_Single_Line']}</td>
            <td colSpan={'3'}>{summaryData['Matched_UPRN_Single_Line']}</td>
            <td>{translations['Meter_GISX']}</td>
            <td>{summaryData['GISX']}</td>
          </tr>
          <tr>
            <td>{translations['CMOS_VOA_Single_Line']}</td>
            <td colSpan={'3'}>{summaryData['CMOS_VOA_Single_Line']}</td>
            <td>{translations['Meter_GISY']}</td>
            <td>{summaryData['GISY']}</td>
          </tr>
          <tr>
            <td>{translations['Matched_VOA_Single_Line']}</td>
            <td colSpan={'9'}>{summaryData['Matched_VOA_Single_Line']}</td>
          </tr>
          <tr>
            <td>{translations['Meter_Address']}</td>
            <td colSpan={'9'}>{summaryData['Meter_Address_Single_Line']}</td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

export const CMOSLive = ({ translations, summaryData: data }) => {
  const rows = useMemo(() => {
    return [
      [translations['CL_VOA_BA_Reference'], 'CL_VOA_BA_Reference'],
      [translations['CL_UPRN'], 'CL_UPRN'],
      [translations['CL_PAF_Address_Key'], 'CL_PAF_Address_Key'],
      [translations['CL_Free_Descriptor'], 'CL_Free_Descriptor'],
      [translations['CL_Secondary_Addressable_Object'], 'CL_Secondary_Addressable_Object'],
      [translations['CL_Primary_Addressable_Object'], 'CL_Primary_Addressable_Object'],
      [translations['CL_Address_Line_1'], 'CL_Address_Line_1'],
      [translations['CL_Address_Line_2'], 'CL_Address_Line_2'],
      [translations['CL_Address_Line_3'], 'CL_Address_Line_3'],
      [translations['CL_Address_Line_4'], 'CL_Address_Line_4'],
      [translations['CL_Address_Line_5'], 'CL_Address_Line_5'],
      [translations['CL_Postcode'], 'CL_Postcode'],
    ]
  }, [translations])
  return (
    <div>
      <GenericTable style={{height: '100%'}} biggerSecondRow={false} firstColWidth={150} title={translations['Header_CmosLive']} rows={rows} extraClass="squish smaller-text left" evidence={false} data={data} />
    </div>
  )
}

export const AddressBase = ({ translations, summaryData: data, selectedMatches, setSelectedMatches }) => {
  const [loading, setLoading] = useState(false);
  const [addresses, setAddresses] = useState([]);
  const [postcodeModal, setPostcodeModal] = useState(false);
  const [customPostcode, setCustomPostcode] = useState('');
  const [clearMatchModal, setClearMatchModal] = useState(false);
  const [index, setIndex] = useState(0);

  const cycleIndex = (change = 0) => {
    if (index + change <= -1) return
    if (index + change >= addresses.length) return
    setIndex(index + change)
  }

  const getData = (customInput) => {
    if (!customInput && !customPostcode && (!data.ABP_Postcode || data.Address_Status === 'Invalid Postcode') && data.CL_Postcode) {
        setLoading(false);
        return;
    }
    setAddresses([]);
    request(true)
      .get(endpoints.MOSL_ELIGIBILITY_GET_ADDRESSES, {
        doesCancel: true,
        params: {
          postcode: customInput || customPostcode || data.ABP_Postcode || data.CL_Postcode
        }
      })
      .then(e => {
        const _data = e.data;
        setAddresses(_data);
        if (data.CF_UPRN) {
          const displayFirst = _data.findIndex(_ => _.UPRN === parseInt(data.CF_UPRN))
          setIndex(displayFirst)
          setSelectedMatches((prevMatches) => {
            return {
              ...prevMatches,
              abp: data.CF_UPRN.toString()
            };
          });
        }
        setLoading(false)
      })
      .catch(_ => { window.alert('Could not get Address Base data.'); setAddresses([]); setLoading(false) });
  };

  useEffect(() => {
    setAddresses([])
    setIndex(-1)
    if (data.SPIDCORE) {
      setIndex(-1)
      setCustomPostcode('');
      setLoading(true)
      getData(data.ABP_Postcode || data.CL_Postcode)
    }
  }, [data.SPIDCORE]);

  useEffect(() => {
    if (customPostcode !== '') return
    if (!data.SPIDCORE) {
      setLoading(false)
      setAddresses([])
    } else {
      getData();
    }
  }, [customPostcode])

  const originalPostcode = useMemo(() => {
    return data.ABP_Postcode || data.CL_Postcode;
  }, [data.ABP_Postcode, data.CL_Postcode]);

  const selectMatch = useCallback(() => {
    if (!addresses[index]?.UPRN) return
    if (selectedMatches.abp == addresses[index].UPRN) {
      setSelectedMatches((prevMatches) => {
        return {
          ...prevMatches,
          abp: ''
        };
      });
    } else {
      setSelectedMatches((prevMatches) => {
        return {
          ...prevMatches,
          abp: typeof addresses[index].UPRN === "number" ? addresses[index].UPRN.toString() : addresses[index].UPRN
        };
      });
    }
  }, [addresses, selectedMatches, setSelectedMatches, index])

  return (
    <div>
      <table className='table borders squish smaller-text left' style={{height: '100%'}}>
        <thead>
          <tr>
            <th style={{ textAlign: 'start' }} colSpan={2}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                {translations['Header_AddressBase']}
                <div style={{ marginLeft: 'auto', display: 'flex', gap: 10 }}>
                  {customPostcode && (
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                      <span className='fas fa-trash-undo' onClick={() => { setCustomPostcode(''); setLoading(true) }} title="Restore original postcode search"></span>
                    </div>
                  )}
                  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    <span className='fas fa-search' onClick={() => setPostcodeModal(true)} title="Search for a different postcode"></span>
                  </div>
                  {
                    addresses.length ? <>
                      <span style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                        <span className='fas fa-angle-left' onClick={() => cycleIndex(-1)}></span>
                        <span style={{minWidth: 60, textAlign: 'center'}}>{index+1}/{addresses.length}</span>
                        <span className='fas fa-angle-right' onClick={() => cycleIndex(1)}></span>
                      </span>
                    </> : null
                  }
                </div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{translations['UPRN']}</td>
            <td style={{minWidth: '60px', textAlign: loading ? 'center' : 'unset'}}>
              { 
                loading ?
                  <i className="fa fa-spinner fa-spin"></i>
                  :
                  addresses[index]?.UPRN ?? '' 
              }</td>
          </tr>
          <tr>
            <td>{translations['CLASSIFICATION_CODE']}</td>
            <td style={{minWidth: '60px'}}>{ addresses[index]?.CLASSIFICATION_CODE?? '' }</td>
          </tr>
          <tr>
            <td>{translations['UDPRN']}</td>
            <td style={{minWidth: '60px'}}>{ addresses[index]?.UDPRN ?? '' }</td>
          </tr>
          <tr>
            <td>{translations['ORGANISATION']}</td>
            <td style={{minWidth: '60px'}}>{ addresses[index]?.ORGANISATION ?? '' }</td>
          </tr>
          <tr>
            <td>{translations['SUB_BUILDING']}</td>
            <td style={{minWidth: '60px'}}>{ addresses[index]?.SUB_BUILDING ?? '' }</td>
          </tr>
          <tr>
            <td>{translations['BUILDING_NAME']}</td>
            <td style={{minWidth: '60px'}}>{ addresses[index]?.BUILDING_NAME ?? '' }</td>
          </tr>
          <tr>
            <td>{translations['BUILDING_NUMBER']}</td>
            <td style={{minWidth: '60px'}}>{ addresses[index]?.BUILDING_NUMBER ?? '' }</td>
          </tr>
          <tr>
            <td>{translations['STREET_NAME']}</td>
            <td style={{minWidth: '60px'}}>{ addresses[index]?.STREET_NAME ?? '' }</td>
          </tr>
          <tr>
            <td>{translations['LOCALITY']}</td>
            <td style={{minWidth: '60px'}}>{ addresses[index]?.LOCALITY ?? '' }</td>
          </tr>
          <tr>
            <td>{translations['TOWN_NAME']}</td>
            <td style={{minWidth: '60px'}}>{ addresses[index]?.TOWN_NAME ?? '' }</td>
          </tr>
          <tr>
            <td>{translations['POST_TOWN']}</td>
            <td style={{minWidth: '60px'}}>{ addresses[index]?.POST_TOWN ?? '' }</td>
          </tr>
          <tr>
            <td>{translations['Postcode']}</td>
            <td style={{minWidth: '60px'}}>{ addresses[index]?.POSTCODE ?? '' }</td>
          </tr>
          <tr>
            <td style={{minWidth: '60px'}}><button className={`button compact smaller-text ${data.CF_UPRN ? 'cancel colour-white' : ''}`} onClick={() => setClearMatchModal(data.CF_UPRN ? true : false) }>Clear Match</button></td>
            <td style={{minWidth: '60px'}}><button className={`button compact smaller-text ${selectedMatches.abp && selectedMatches.abp == addresses[index]?.UPRN ? 'background-primary colour-white' : ''}`} onClick={() => selectMatch()}>Select Match</button></td>
          </tr>
        </tbody>
      </table>
      <ReactModal
        isOpen={postcodeModal}
        onRequestClose={() => setPostcodeModal(false)}
        className="card bulk-allocate"
        contentLabel="Bulk Allocate COT Alert Data"
        style={{ overlay: { backgroundColor: 'rgba(14, 14, 14, 0.55)' } }}
      >
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          <h3>Postcode Search</h3>
          <input value={customPostcode ? customPostcode : originalPostcode} onChange={_ => setCustomPostcode(_.target.value.toUpperCase())} style={{ border: '1px solid gray', width: '100%', borderRadius: 3 }} />
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
            <button className={`button compact smaller-text ${customPostcode?.length >= 3 ? 'background-primary colour-white' : ''}`} disabled={customPostcode?.length < 3} onClick={() => { getData(customPostcode); setPostcodeModal(false); setLoading(true) }}>Search</button>
          </div>
        </div>
      </ReactModal>
      <ReactModal
        isOpen={clearMatchModal}
        onRequestClose={() => setClearMatchModal(false)}
        className="card bulk-allocate"
        contentLabel="Bulk Allocate COT Alert Data"
        style={{ overlay: { backgroundColor: 'rgba(14, 14, 14, 0.55)' } }}
      >
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          <h3>Clear existing match</h3>
          <p>Please confirm you wish to clear the following matched UPRN for ABP on this SPID.</p>
          <ul className='spid-list'>
            <li>SPID: {data.SPIDCORE}</li>
            <li>ABP UPRN: {data.CF_UPRN}</li>
          </ul>
          <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', alignItems: 'center'}}>
            <button className="button compact smaller-text cancel" onClick={ () => setClearMatchModal(false) }>Cancel</button>
            <button className="button compact smaller-text background-primary colour-white" onClick={() => {
              request(true).post(endpoints.MOSL_ELIGIBILITY_CLEAR_MATCH, {
                spid: data.SPIDCORE,
                matchType: 'abp'
              }).then(r => {
                window.reloadSummaryData()
                setClearMatchModal(false); 
              })
            }}
            >Confirm</button> 
          </div>
        </div>
      </ReactModal>
    </div>
  );
};

export const ValuationOffice = ({ translations, summaryData: data, selectedMatches, setSelectedMatches }) => {
  const [loading, setLoading] = useState(false);
  const [voas, setVoas] = useState([])
  const [postcodeModal, setPostcodeModal] = useState(false);
  const [customPostcode, setCustomPostcode] = useState('');
  const [clearMatchModal, setClearMatchModal] = useState(false);
  const [index, setIndex] = useState(0);

  const cycleIndex = (change = 0) => {
    if (index + change <= -1) return
    if (index + change >= voas.length) return
    setIndex(index + change)
  }

  const getData = (customInput) => {
    if (!customInput && !customPostcode && (!data.ABP_Postcode || data.Address_Status === 'Invalid Postcode') && data.CL_Postcode) {
        setLoading(false);
        return;
    }
    setVoas([])
    request(true).get(data.Wholesaler === "SCOTTISH-W" ? endpoints.MOSL_ELIGIBILITY_GET_SAA : endpoints.MOSL_ELIGIBILITY_GET_VOAS, {
      doesCancel: true,
      params: {
        postcode: customInput || customPostcode || data.VO_Postcode || data.CL_Postcode
      }
    }).then(e => {
      const _data = e.data
      setVoas(_data);
      if (data.Matched_VOA_No) {
        const displayFirst = _data.findIndex(_ => _.BA_Reference_Number === data.Matched_VOA_No && _.Postcode === data.CL_Postcode)
        setIndex(displayFirst);
        setSelectedMatches((prevMatches) => {
          return {
            ...prevMatches,
            voa: typeof data.Matched_VOA_No === "number" ? data.Matched_VOA_No.toString() : data.Matched_VOA_No
          };
        });
      }
      setLoading(false)
    }).catch(() => {
      window.alert('Could not get Valuation Office data');
      setVoas([])
      setLoading(false)
    })
  }

  useEffect(() => {
    setVoas([])
    setIndex(-1)
    if (data.SPIDCORE) {
      setIndex(-1)
      setCustomPostcode('')
      setLoading(true)
      getData(data.ABP_Postcode || data.CL_Postcode)
    }
  }, [data.SPIDCORE])

  // const selectedVOA = useMemo(() => {
  //   const selected = voas.length > -1 ? voas[index] : null;
  //   if (!selected ) return {}
  //   selected.Source = data.Wholesaler === "SCOTTISH-W" || data.Wholesaler === "SW" ? 'SAA' : 'Business Rates'
  //   selected.Deletion_Date = selected.Effective_Status === 'DELETED' ? selected.Current_From_Date : ''
  //   setPostcode(selected.Postcode)
  //   return selected
  // }, [voas, index, data, setPostcode]);

  useEffect(() => {
    if (customPostcode !== '') return 
    if (!data.SPIDCORE) {
      setVoas([])
      setLoading(false)
    } else {
      getData();
    }
  }, [customPostcode])

  const selectMatch = useCallback(() => {
    if (!voas[index]?.BA_Reference_Number) return
    if (selectedMatches.voa == voas[index].BA_Reference_Number) {
      setSelectedMatches((prevMatches) => {
        return {
          ...prevMatches,
          voa: ''
        };
      });
    } else {
      setSelectedMatches((prevMatches) => {
        return {
          ...prevMatches,
          voa: typeof voas[index].BA_Reference_Number === "number" ? voas[index].BA_Reference_Number.toString() : voas[index].BA_Reference_Number
        };
      });
    }
  }, [voas, selectedMatches, setSelectedMatches, index])

  const originalPostcode = useMemo(() => {
    return data.VO_Postcode || data.CL_Postcode
  }, [data.ABP_Postcode, data.CL_Postcode])

  return [
    <table className='table borders squish smaller-text left' style={{height: '100%'}}>
      <thead>
        <tr>
          <th style={{ textAlign: 'start' }} colSpan={2}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              {translations['Header_Valuation']}
              <div style={{ marginLeft: 'auto', display: 'flex', gap: 10 }}>
                {customPostcode && (
                  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    <span className='fas fa-trash-undo' onClick={() => { setCustomPostcode(''); setLoading(true); }} title="Restore original postcode search"></span>
                  </div>
                )}
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                  <span className='fas fa-search' onClick={() => setPostcodeModal(true)} title="Search for a different postcode"></span>
                </div>
                {
                  voas.length ? <>
                    <span style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                      <span className='fas fa-angle-left' onClick={() => cycleIndex(-1)}></span>
                      <span style={{minWidth: 60, textAlign: 'center'}}>{index+1}/{voas.length}</span>
                      <span className='fas fa-angle-right' onClick={() => cycleIndex(1)}></span>
                    </span>
                  </> : null
                }
              </div>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{translations['BA_Reference_Number']}</td>
          <td style={{minWidth: '60px', textAlign: loading ? 'center' : 'unset'}}>
            { 
              loading ? 
                <i className="fa fa-spinner fa-spin"></i>
                :
                voas[index]?.BA_Reference_Number ?? '' 
            }
          </td>
        </tr>
        <tr>
          <td>{translations['Primary_Description_Text']}</td>
          <td style={{minWidth: '60px'}}>{ data.Wholesaler === "SCOTTISH-W" || data.Wholesaler === "SW" ? voas[index]?.DESCRIP?? '' : voas[index]?.Primary_Description_Text ?? '' }</td>
        </tr>
        <tr>
          <td>{translations['Source']}</td>
          <td style={{minWidth: '60px'}}>{ voas[index]?.Source ?? '' }</td>
        </tr>
        <tr>
          <td>{translations['Number_Or_Name']}</td>
          <td style={{minWidth: '60px'}}>{ data.Wholesaler === "SCOTTISH-W" || data.Wholesaler === "SW" ? voas[index]?.PAON ?? '' : voas[index]?.Number_Or_Name ?? '' }</td>
        </tr>
        <tr>
          <td>{translations['Street']}</td>
          <td style={{minWidth: '60px'}}>{ data.Wholesaler === "SCOTTISH-W" || data.Wholesaler === "SW" ? voas[index]?.STREET ?? '' : voas[index]?.Street ?? '' }</td>
        </tr>
        <tr>
          <td>{translations['Sub_Street_level_1']}</td>
          <td style={{minWidth: '60px'}}>{ voas[index]?.Sub_Street_Level_1 ?? '' }</td>
        </tr>
        <tr>
          <td>{translations['Town']}</td>
          <td style={{minWidth: '60px'}}>{ data.Wholesaler === "SCOTTISH-W" || data.Wholesaler === "SW" ? voas[index]?.TOWN ?? '' : voas[index]?.Town ?? '' }</td>
        </tr>
        <tr>
          <td>{translations['Postal_District']}</td>
          <td style={{minWidth: '60px'}}>{ data.Wholesaler === "SCOTTISH-W" || data.Wholesaler === "SW" ? voas[index]?.ADMIN_AREA ?? '' : voas[index]?.Postal_District ?? '' }</td>
        </tr>
        <tr>
          <td>{translations['County']}</td>
          <td style={{minWidth: '60px'}}>{ data.Wholesaler === "SCOTTISH-W" || data.Wholesaler === "SW" ? voas[index]?.UNITARY_AUTHORITY ?? '' : voas[index]?.County ?? '' }</td>
        </tr>
        <tr>
          <td>{translations['Postcode']}</td>
          <td style={{minWidth: '60px'}}>{ data.Wholesaler === "SCOTTISH-W" || data.Wholesaler === "SW" ? voas[index]?.BR_Postcode ?? '' : voas[index]?.Postcode ?? '' }</td>
        </tr>
        <tr>
          <td>{translations['Effective_Status']}</td>
          <td style={{minWidth: '60px'}}>{ data.Wholesaler === "SCOTTISH-W" || data.Wholesaler === "SW" ? voas[index]?.OCC_STATUS ?? '' : voas[index]?.Effective_Status ?? '' }</td>
        </tr>
        <tr>
          <td>{translations['Deletion_Date']}</td>
          <td style={{minWidth: '60px'}}>{ voas[index]?.Deletion_Date ?? '' }</td>
        </tr>
        <tr>
          <td style={{minWidth: '60px'}}><button className={`button compact smaller-text ${data.Matched_VOA_No ? 'cancel colour-white' : ''}`} onClick={() => setClearMatchModal(data.Matched_VOA_No ? true : false) }>Clear Match</button></td>
          <td style={{minWidth: '60px'}}><button className={`button compact smaller-text ${selectedMatches.voa && selectedMatches.voa == voas[index]?.BA_Reference_Number ? 'background-primary colour-white' : ''}`} onClick={() => selectMatch()}>Select Match</button></td>
        </tr>
      </tbody>
    </table>,
    <ReactModal 
    isOpen={postcodeModal} 
    onRequestClose={() => setPostcodeModal(false)}
    className="card bulk-allocate"
    contentLabel="Bulk Allocate COT Alert Data"
    style={{ overlay: { backgroundColor: 'rgba(14, 14, 14, 0.55)' } }}>
      <div style={{display: 'flex', flexDirection: 'column', gap: 10}}>
        <h3>Postcode Search</h3>
        <input value={customPostcode} onChange={_ => setCustomPostcode(_.target.value)} style={{border: '1px solid gray', width: '100%', borderRadius: 3}} />
        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center'}}>
          <button className={`button compact smaller-text ${customPostcode?.length >= 3 ? 'background-primary colour-white' : ''}`} disabled={customPostcode?.length < 3} onClick={() => {getData(customPostcode || undefined); setLoading(true); setPostcodeModal(false)}}>Search</button> 
        </div>
      </div>
    </ReactModal>,
    <ReactModal
      isOpen={clearMatchModal}
      onRequestClose={() => setClearMatchModal(false)}
      className="card bulk-allocate"
      contentLabel="Bulk Allocate COT Alert Data"
      style={{ overlay: { backgroundColor: 'rgba(14, 14, 14, 0.55)' } }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        <h3>Clear existing match</h3>
        <p>Please confirm you wish to clear the following matched Reference for VOA on this SPID.</p>
        <ul className='spid-list'>
          <li>SPID: {data.SPIDCORE}</li>
          <li>VOA Reference: {data.Matched_VOA_No}</li>
        </ul>
        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', alignItems: 'center'}}>
          <button className="button compact smaller-text cancel" onClick={ () => setClearMatchModal(false) }>Cancel</button>
          <button className="button compact smaller-text background-primary colour-white" onClick={() => {
            request(true).post(endpoints.MOSL_ELIGIBILITY_CLEAR_MATCH, {
              spid: data.SPIDCORE,
              matchType: 'voa'
            }).then(r => {
              window.reloadSummaryData()
              setClearMatchModal(false); 
            })
          }}
          >Confirm</button> 
        </div>
      </div>
    </ReactModal>
  ]
}

export const CouncilTax = ({ translations, summaryData: data, selectedMatches, setSelectedMatches }) => {
  const [loading, setLoading] = useState(false);
  const [addresses, setAddresses] = useState([]);
  const [postcodeModal, setPostcodeModal] = useState(false);
  const [customPostcode, setCustomPostcode] = useState('');
  const [clearMatchModal, setClearMatchModal] = useState(false);
  const [index, setIndex] = useState(0);

  const cycleIndex = (change = 0) => {
    if (index + change <= -1) return
    if (index + change >= addresses.length) return
    setIndex(index + change)
  }

  const getData = (customInput) => {
    if (!customInput && !customPostcode && (!data.ABP_Postcode || data.Address_Status === 'Invalid Postcode') && data.CL_Postcode) {
        setLoading(false);
        return;
    }
    setAddresses([])
    request(true).get(endpoints.MOSL_ELIGIBILITY_GET_CT, {
      doesCancel: true,
      params: {
        postcode: customInput || customPostcode || data.ABP_Postcode || data.CL_Postcode
      }
    })
    .then(e => {
      const _data = e.data;
      setAddresses(_data)
      if (data.au_reference_number) {
        const displayFirst = _data.findIndex(_ => _.au_reference_number === data.au_reference_number) 
        setIndex(displayFirst);
        setSelectedMatches((prevMatches) => {
          return {
            ...prevMatches,
            ct: typeof data.au_reference_number === "nummber" ? data.au_reference_number.toString() : data.au_reference_number 
          };
        });
      }
      setLoading(false)
    })
    .catch(_ => { window.alert('Could not get Council Tax data.'); setAddresses([]); setLoading(false) })
  };

  useEffect(() => {
    setAddresses([])
    setIndex(-1)
    if (data.SPIDCORE) {
      setIndex(-1)
      setCustomPostcode('')
      setLoading(true)
      getData(data.ABP_Postcode || data.CL_Postcode)
    }
  }, [data.SPIDCORE])

  const tableData = useMemo(() => {
    const selected = addresses.length > -1 ?  addresses[index] : null;
    if (!selected ) return {}
    selected.STATUS = selected.CHANGE_CODE === 'D' ? 'Deleted' : 'Active';
    // setCustomPostcode(selected.Postcode)
    if (selected.address) {
      const addressLines = parseAddress(selected.address)
      addressLines.forEach((line, index) => {
        selected['CT_Address_Line_' + (index + 1)] = line
      })
    }
    return selected
  }, [addresses, index]);

  const originalPostcode = useMemo(() => {
    return data.VO_Postcode || data.CL_Postcode
  }, [data.ABP_Postcode, data.CL_Postcode])

  const selectMatch = useCallback(() => {
    if (!addresses[index]?.au_reference_number) return
    if (selectedMatches.ct == addresses[index].au_reference_number) {
      setSelectedMatches((prevMatches) => {
        return {
          ...prevMatches,
          ct: ''
        };
      });
    } else {
      setSelectedMatches((prevMatches) => {
        return {
          ...prevMatches,
          ct: typeof addresses[index].au_reference_number === "number" ? addresses[index].au_reference_number.toString() : addresses[index].au_reference_number
        };
      });
    }
  }, [addresses, selectedMatches, setSelectedMatches, index])

  function parseAddress(address) {

    const addressLines = address.split(", ");

    return addressLines;
}

  const rows = useMemo(() => {
    return [
      [translations['CT_Reference'], 'au_reference_number'],
      [translations['CT_Band'], 'council_tax_band'],
      [translations['CT_Mixed_Use_Property'], 'mixed_use_property'],
      [translations['CF_Free_Descriptor'], 'CT_Free_Descriptor'],
      [translations['CF_Secondary_Addressable_Object'], 'CT_Secondary_Addressable_Object'],
      [translations['CF_Primary_Addressable_Object'], 'CT_Primary_Addressable_Object'],
      [translations['CF_Address_Line_1'], 'CT_Address_Line_1'],
      [translations['CF_Address_Line_2'], 'CT_Address_Line_2'],
      [translations['CF_Address_Line_3'], 'CT_Address_Line_3'],
      [translations['CF_Address_Line_4'], 'CT_Address_Line_4'],
      [translations['CT_Band'], 'council_tax_band'],
      [translations['CF_Postcode'], 'postcode'],
      ['', () => <button className={`button compact smaller-text ${selectedMatches.ct && selectedMatches.ct === addresses[index?.au_reference_number] ? 'background-primary colour-white' : ''}`} onClick={() => selectMatch()}>Select Match</button>]
    ]
  }, [translations, window.reloadSummaryData, index])
  return (
    <div>
      <table className='table borders squish smaller-text left' style={{height: '100%'}}>
        <thead>
          <tr>
            <th style={{ textAlign: 'start' }} colSpan={2}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                {translations['Council_Tax']}
                <div style={{ marginLeft: 'auto', display: 'flex', gap: 10 }}>
                  {customPostcode && (
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                      <span className='fas fa-trash-undo' onClick={() => { setCustomPostcode(''); getData(); setLoading(true); }} title="Restore original postcode search"></span>
                    </div>
                  )}
                  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    <span className='fas fa-search' onClick={() => setPostcodeModal(true)} title="Search for a different postcode"></span>
                  </div>
                  {
                    addresses.length ? <>
                      <span style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                        <span className='fas fa-angle-left' onClick={() => cycleIndex(-1)}></span>
                        <span style={{minWidth: 60, textAlign: 'center'}}>{index+1}/{addresses.length}</span>
                        <span className='fas fa-angle-right' onClick={() => cycleIndex(1)}></span>
                      </span>
                    </> : null
                  }
                </div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{translations['CT_Reference']}</td>
            <td style={{minWidth: '60px', textAlign: loading ? 'center' : 'unset'}}>
              {
                loading ? 
                  <i className="fa fa-spinner fa-spin"></i>
                  :
                  addresses[index]?.au_reference_number ?? '' 
              }
            </td>
          </tr>
          <tr>
            <td>{translations['CT_Band']}</td>
            <td style={{minWidth: '60px'}}>{ addresses[index]?.council_tax_band ?? '' }</td>
          </tr>
          <tr>
            <td>{translations['CT_Mixed_Use_Property']}</td>
            <td style={{minWidth: '60px'}}>{ addresses[index]?.mixed_use_property ?? '' }</td>
          </tr>
          <tr>
            <td>{translations['CF_Free_Descriptor']}</td>
            <td style={{minWidth: '60px'}}>{ addresses[index]?.CT_Free_Descriptor ?? '' }</td>
          </tr>
          <tr>
            <td>{translations['CF_Secondary_Addressable_Object']}</td>
            <td style={{minWidth: '60px'}}>{ addresses[index]?.CT_Secondary_Addressable_Object ?? '' }</td>
          </tr>
          <tr>
            <td>{translations['CF_Primary_Addressable_Object']}</td>
            <td style={{minWidth: '60px'}}>{ addresses[index]?.CT_Primary_Addressable_Object ?? '' }</td>
          </tr>
          <tr>
            <td>{translations['CF_Address_Line_1']}</td>
            <td style={{minWidth: '60px'}}>{ addresses[index]?.CT_Address_Line_1 ?? '' }</td>
          </tr>
          <tr>
            <td>{translations['CF_Address_Line_2']}</td>
            <td style={{minWidth: '60px'}}>{ addresses[index]?.CT_Address_Line_2 ?? '' }</td>
          </tr>
          <tr>
            <td>{translations['CF_Address_Line_3']}</td>
            <td style={{minWidth: '60px'}}>{ addresses[index]?.CT_Address_Line_3 ?? '' }</td>
          </tr>
          <tr>
            <td>{translations['CF_Address_Line_4']}</td>
            <td style={{minWidth: '60px'}}>{ addresses[index]?.CT_Address_Line_4 ?? '' }</td>
          </tr>
          <tr>
            <td>{translations['CT_Band']}</td>
            <td style={{minWidth: '60px'}}>{ addresses[index]?.council_tax_band ?? '' }</td>
          </tr>
          <tr>
            <td>{translations['CF_Postcode']}</td>
            <td style={{minWidth: '60px'}}>{ addresses[index]?.postcode ?? '' }</td>
          </tr>
          <tr>
            <td style={{minWidth: '60px'}}><button className={`button compact smaller-text ${data.au_reference_number ? 'cancel colour-white' : ''}`} onClick={() => setClearMatchModal(data.au_reference_number ? true : false) }>Clear Match</button></td>
            <td style={{minWidth: '60px'}}><button className={`button compact smaller-text ${selectedMatches.ct && selectedMatches.ct == addresses[index]?.au_reference_number ? 'background-primary colour-white' : ''}`} onClick={() => selectMatch()}>Select Match</button></td>
          </tr>
        </tbody>
      </table>
      <ReactModal 
      isOpen={postcodeModal} 
      onRequestClose={() => setPostcodeModal(false)}
      className="card bulk-allocate"
      contentLabel="Bulk Allocate COT Alert Data"
      style={{ overlay: { backgroundColor: 'rgba(14, 14, 14, 0.55)' } }}>
        <div style={{display: 'flex', flexDirection: 'column', gap: 10}}>
          <h3>Postcode Search</h3>
          <input value={customPostcode} onChange={_ => setCustomPostcode(_.target.value)} style={{border: '1px solid gray', width: '100%', borderRadius: 3}} />
          <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center'}}>
            <button className={`button compact smaller-text ${customPostcode?.length >= 3 ? 'background-primary colour-white' : ''}`} disabled={customPostcode?.length < 3} onClick={() => {getData(customPostcode || undefined); setLoading(true); setPostcodeModal(false)}}>Search</button> 
          </div>
        </div>
      </ReactModal>
      <ReactModal
        isOpen={clearMatchModal}
        onRequestClose={() => setClearMatchModal(false)}
        className="card bulk-allocate"
        contentLabel="Bulk Allocate COT Alert Data"
        style={{ overlay: { backgroundColor: 'rgba(14, 14, 14, 0.55)' } }}
      >
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          <h3>Clear existing match</h3>
          <p>Please confirm you wish to clear the following matched Reference for Council Tax on this SPID.</p>
          <ul className='spid-list'>
            <li>SPID: {data.SPIDCORE}</li>
            <li>CT Reference: {data.au_reference_number}</li>
          </ul>
          <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', alignItems: 'center'}}>
            <button className="button compact smaller-text cancel" onClick={ () => setClearMatchModal(false) }>Cancel</button>
            <button className="button compact smaller-text background-primary colour-white" onClick={() => {
              request(true).post(endpoints.MOSL_ELIGIBILITY_CLEAR_MATCH, {
                spid: data.SPIDCORE,
                matchType: 'ct'
              }).then(r => {
                window.reloadSummaryData()
                setClearMatchModal(false); 
              })
            }}
            >Confirm</button> 
          </div>
        </div>
      </ReactModal>
    </div>
  )
}

export const CMOSFormatted = ({ translations, summaryData, setSummaryData, selectedMatches, workflow, setConfirmModal }) => {
  const updateAddress = () => {
    request(true).post(endpoints.MOSL_ELIGIBILITY_SELECT_MATCH, {
      spid: summaryData.SPIDCORE,
      ba_reference: selectedMatches.voa ?? '',
      abp_uprn: selectedMatches.abp ??'',
      ct_reference: selectedMatches.ct ?? ''
    }).then(r => {
      window.reloadSummaryData()
    })
  }
  const rows = useMemo(() => {
    var disabled = true;
    if (summaryData) {
      var abpDifferent = selectedMatches.abp !== '' && selectedMatches.abp !== summaryData.CF_UPRN
      var voaDifferent = selectedMatches.voa !== '' && selectedMatches.voa !== summaryData.CF_VOA_BA_Reference
      var ctDifferent = selectedMatches.ct !== '' && selectedMatches.ct !== summaryData.au_reference_number
      if (abpDifferent || voaDifferent || ctDifferent) {
        disabled = false;
      }
    }

    return [
      [translations['CF_VOA_BA_Reference'], 'CF_VOA_BA_Reference'],
      [translations['CF_UPRN'], 'CF_UPRN'],
      [translations['CF_PAF_Address_Key'], 'CF_PAF_Address_Key'],
      [translations['CT_Reference'], 'au_reference_number'],
      [translations['CF_Secondary_Addressable_Object'], 'CF_Secondary_Addressable_Object'],
      [translations['CF_Primary_Addressable_Object'], 'CF_Primary_Addressable_Object'],
      [translations['CF_Address_Line_1'], 'CF_Address_Line_1'],
      [translations['CF_Address_Line_2'], 'CF_Address_Line_2'],
      [translations['CF_Address_Line_3'], 'CF_Address_Line_3'],
      [translations['CF_Address_Line_4'], 'CF_Address_Line_4'],
      [translations['CT_Band'], 'Council_Tax_Band'],
      [translations['CF_Postcode'], 'CF_Postcode'],
      [({summaryData}) => 
        <button 
          // className='button compact smaller-text' 
          className={`button compact smaller-text ${!disabled ? 'background-primary colour-white' : ''}`} 
          onClick={() => !disabled && updateAddress()}
        >Update Address</button>,         
        ({}) => 
        <button 
          // className='button compact smaller-text' 
          className={`button compact smaller-text background-primary colour-white`} 
          onClick={() => setConfirmModal(true)}
        >Confirm</button>],
    ]
  }, [translations, updateAddress])
  // const fields = [
  //   'ABP_Sub_Building',
  //   'ABP_Building_Name',
  //   'ABP_Building_Number',
  //   'ABP_Street_Name',
  //   'ABP_Town_Name',
  //   'ABP_Post_Town',
  //   'ABP_Postcode'
  // ];

  // const addressLines = [
  //   'CF_Address_Line_1',
  //   'CF_Address_Line_2',
  //   'CF_Address_Line_3',
  //   'CF_Address_Line_4',
  //   'CF_Address_Line_5',
  //   'CF_Postcode'
  // ];

  // const components = fields.map(field => summaryData[field]).filter(value => value && value.trim() !== '');

  // components.forEach((component, index) => {
  //   if (index < addressLines.length) {
  //     summaryData[addressLines[index]] = component;
  //   }
  // });

  // for (let i = components.length; i < addressLines.length; i++) {
  //   summaryData[addressLines[i]] = '';
  // }
  return (
    <GenericTable biggerSecondRow={false} firstColWidth={155} title={translations['Header_CmosFormatted']} rows={rows} extraClass="squish smaller-text left" evidence={false} data={summaryData} />
  )
}